import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class ExistingNavRequest {
  constructor(init) {
    if (isNil(init)) return undefined

    this._member_name = init.existing_nav_request_member_name
    this._date_of_birth = init.existing_nav_request_date_of_birth
    this._date_of_original_interaction =
      init.existing_nav_request_date_of_original_interaction
    this._issue_summary = init.existing_nav_request_issue_summary
    this._requested_action = init.existing_nav_request_requested_action
    this._contact_method_type = init.existing_nav_request_contact_method_type
    this._contact_method_value = init.existing_nav_request_contact_method_value
    this._best_time_to_reach = init.existing_nav_request_best_time_to_reach
    this._interaction_summary = init.existing_nav_request_interaction_summary
    this._other_notes = init.existing_nav_request_other_notes
    this._request_type = init.existing_nav_request_request_type

    this._user_email = init.user_email
    this._user_name = init.user_name
    this._user_phone_number = init.user_phone_number
    this._organization_name = init.organization_name
    this._users_job_title = init.users_job_title
  }

  static shape = {
    member_name: PropTypes.string.isRequired,
    date_of_birth: PropTypes.string.isRequired,
    date_of_original_interaction: PropTypes.string.isRequired,
    issue_summary: PropTypes.string.isRequired,
    requested_action: PropTypes.string.isRequired,
    contact_method_type: PropTypes.string.isRequired,
    contact_method_value: PropTypes.string.isRequired,
    best_time_to_reach: PropTypes.string,
    interaction_summary: PropTypes.string,
    other_notes: PropTypes.string,
    request_type: PropTypes.string.isRequired,

    user_email: PropTypes.string,
    user_name: PropTypes.string,
    user_phone_number: PropTypes.string,
    organization_name: PropTypes.string,
    users_job_title: PropTypes.string
  }

  get member_name() {
    return this._member_name
  }

  get date_of_birth() {
    return this._date_of_birth
  }

  get date_of_original_interaction() {
    return this._date_of_original_interaction
  }

  get issue_summary() {
    return this._issue_summary
  }

  get requested_action() {
    return this._requested_action
  }

  get contact_method_type() {
    return this._contact_method_type
  }

  get contact_method_value() {
    return this._contact_method_value
  }

  get best_time_to_reach() {
    return this._best_time_to_reach
  }

  get interaction_summary() {
    return this._interaction_summary
  }

  get other_notes() {
    return this._other_notes
  }

  get request_type() {
    return this._request_type
  }

  get user_email() {
    return this._user_email
  }

  get user_name() {
    return this._user_name
  }

  get user_phone_number() {
    return this._user_phone_number
  }

  get organization_name() {
    return this._organization_name
  }

  get users_job_title() {
    return this._users_job_title
  }
}

export default ExistingNavRequest
